import React, { useState } from 'react';
import { Bus, Route, Wrench, GraduationCap } from 'lucide-react';
import './MissionSection.css';

const missionData = [

  {
    id: 0,
    icon: '/logo192.png',
    title: 'AI-Powered Solutions for the Future of Transit',
    subtitle: '',
    vision: 'OUR VISION',
    heading: 'The Transit AI Suite - Turning Transit Intelligence Into Action',
    paragraphs: [
`Built for every part of the mobility ecosystem, the Transit AI Suite brings instant, conversational insights and predictive intelligence to your operations.
It connects data, people, and systems so agencies and operators can make smarter decisions, faster - all powered by AI designed specifically for transit. The Transit AI Suite delivers one unified promise:
Smarter data. Faster insights. Better outcomes.
No matter the mode - paratransit, fixed-route, fleet, or K-12 - our AI brings clarity where there was complexity, helping every operator deliver on what matters most: reliable, safe, and equitable transit for all.`
       ]
  },
    {
    id: 1,
    icon: Bus,
    title: 'Demand Response/Paratransit',
    subtitle: 'Intelligent on-demand transit solutions that adapt to rider needs in real-time, optimizing routes and reducing wait times for paratransit services.',
    vision: 'Our Vision',
    heading: '',
    paragraphs: [
     `Public agencies face complex service demands - ADA compliance, dynamic trip scheduling, and budget constraints.
The Transit AI Suite transforms demand-response operations by bringing real-time visibility and automation to every decision.
Key Benefits:
Instant operational insight - Monitor trip performance, cancellations, and no-shows in seconds.
Smarter resource allocation - Predict peak demand and optimize scheduling automatically.
Compliance confidence - ADA-aligned analytics and automated documentation reduce risk and audit burden.
Human-centered automation - Enable staff to focus on service quality instead of spreadsheets.
Impact: Faster eligibility, higher rider satisfaction, and measurable cost savings - with every trip accountable and optimized.`   ]
  },
  {
    id: 2,
    icon: Route,
    title: 'Fixed Route',
    subtitle: 'Smart scheduling and route optimization for traditional transit systems, maximizing efficiency while improving on-time performance and rider satisfaction.',
    vision: 'Our Partnership',
    heading: '',
    paragraphs: [
     `Private and contracted fixed-route providers thrive on precision and predictability.
Transit AI Suite turns fragmented data into unified, actionable insights - optimizing routes, maintenance, and workforce performance.
Key Benefits:
Fleet efficiency at scale - Predict maintenance needs before they cause downtime.
Operational visibility - Track vehicle utilization, route performance, and on-time rates in real time.
Lower costs, higher uptime - AI insights identify rising costs early and automate preventive measures.
Data-driven accountability - Provide partners and clients with transparent, instant performance reporting.
Impact: Increased service reliability, lower operational costs, and stronger customer confidence.`
    ]
  },
  {
    id: 3,
    icon: Wrench,
    title: 'Asset Management',
    subtitle: 'Predictive maintenance and fleet management powered by AI, ensuring vehicles stay on the road longer and operations run smoothly.',
    vision: 'Our Invitation',
    heading: '',
    paragraphs: [
     `Fleet operations generate thousands of data points daily - maintenance, telematics, scheduling, payroll.
The Transit AI Suite connects these into one intelligent system that anticipates issues and enables proactive management.
Key Benefits:
Unified fleet intelligence - All maintenance, driver, and asset data in one real-time dashboard.
Predictive maintenance - Reduce downtime and extend asset life.
Automated workflows - AI handles reporting, updates, and escalation.
Performance transparency - Track labor, utilization, and cost trends instantly.
Impact: Fewer breakdowns, faster repairs, and higher fleet readiness - every vehicle, every shift.`
    ]
  },
  {
    id: 4,
    icon: GraduationCap,
    title: 'AI for School Scheduling',
    subtitle: 'Automated school bus routing and scheduling that balances safety, efficiency, and cost-effectiveness while managing complex student transportation needs.',
    vision: 'Placeholder Vision',
    heading: 'Placeholder Heading',
    paragraphs: [
      `School transportation must balance safety, timing, and transparency.
Transit AI Suite provides districts and operators with visibility and control across every route, bus, and student trip.
Key Benefits:
Real-time fleet visibility - Monitor route performance, driver behavior, and vehicle health.
Safety and compliance - AI-based tracking supports driver accountability and parental peace of mind.
Operational efficiency - Optimize routes and schedules automatically based on attendance and traffic data.
Simplified communication - Get instant insights and share updates with parents, schools, and staff.
Impact: Safer rides, smarter routes, and seamless coordination between districts, parents, and operators.`
    ]
  }
];

const MissionSection = () => {
  const [expandedTile, setExpandedTile] = useState(null);
  const mainContent = missionData.find(item => item.id === 0);
  const tileData = missionData.filter(item => item.id !== 0);

  const handleTileExpand = (id) => {
    setExpandedTile(expandedTile === id ? null : id);
  };

  return (
    <div className="mission-section-wrapper">
      <div className="mission-content-container">
        <div className="mission-centered-text">
          <div className="mission-title-container">
            <img src="/sparkle.png" alt="sparkle" className="sparkle-icon-mission" />
            <span>{mainContent.vision}</span>
          </div>
          <h2>{mainContent.heading}</h2>
          {mainContent.paragraphs.map((p, index) => (
            <p key={index}>{p}</p>
          ))}
        </div>
        <div className="mission-tiles-grid">
          {tileData.map((tile) => (
            <div
              key={tile.id}
              className={`mission-card ${expandedTile !== null ? 'expanded-state' : ''}`}
              onClick={() => handleTileExpand(tile.id)}
              style={{ cursor: 'pointer' }}
            >
              <div className="card-header">
                <div className="card-icon">
                  <tile.icon />
                </div>
                <div className="expand-button">
                  {expandedTile === tile.id ? (
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 10L8 6L12 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  ) : (
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </div>
              </div>
              <h3>{tile.title}</h3>
              <p>{tile.subtitle}</p>
              {expandedTile === tile.id && (
                <div className="card-paragraphs">
                  {tile.paragraphs.map((p, index) => (
                    <p key={index}>{p}</p>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MissionSection;
